/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedPeopleMultipleQueryResponse,
  GetApiV1PersonSharedPeopleMultipleQueryParams,
  GetApiV1PersonSharedPeopleMultiple401,
  GetApiV1PersonSharedPeopleMultiple500,
} from "../../types/courseRegistrationSharedController/GetApiV1PersonSharedPeopleMultiple.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedPeopleMultiple } from "../../clients/courseRegistrationSharedController/getApiV1PersonSharedPeopleMultiple.ts";

export const getApiV1PersonSharedPeopleMultipleQueryKey = (
  params?: GetApiV1PersonSharedPeopleMultipleQueryParams,
) =>
  [
    { url: "/api/v1/person/shared/people-multiple" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1PersonSharedPeopleMultipleQueryKey = ReturnType<
  typeof getApiV1PersonSharedPeopleMultipleQueryKey
>;

export function getApiV1PersonSharedPeopleMultipleQueryOptions(
  params?: GetApiV1PersonSharedPeopleMultipleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedPeopleMultipleQueryKey(params);
  return queryOptions<
    GetApiV1PersonSharedPeopleMultipleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedPeopleMultiple401
      | GetApiV1PersonSharedPeopleMultiple500
    >,
    GetApiV1PersonSharedPeopleMultipleQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedPeopleMultiple(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna pessoas filtradas por nome, tipo e empresa para uso em campos de seleção múltipla. Usuários com papel Polo recebem apenas pessoas vinculadas aos seus polos. A chave retornada tem o prefixo 'USR' (ex.: 'USR123'). **(Requer Authorization para autenticação)**
 * @summary Retorna lista de pessoas para seleção múltipla (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/people-multiple}
 */
export function useGetApiV1PersonSharedPeopleMultiple<
  TData = GetApiV1PersonSharedPeopleMultipleQueryResponse,
  TQueryData = GetApiV1PersonSharedPeopleMultipleQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonSharedPeopleMultipleQueryKey,
>(
  params?: GetApiV1PersonSharedPeopleMultipleQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedPeopleMultipleQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedPeopleMultiple401
          | GetApiV1PersonSharedPeopleMultiple500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedPeopleMultipleQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1PersonSharedPeopleMultipleQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedPeopleMultiple401
      | GetApiV1PersonSharedPeopleMultiple500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
